// The ManufacturingLine a user picks in a section's finder is mirrored in the address bar so the
// selection survives a page refresh and the link can be shared. Each section owns one query
// parameter, manufacturing_line_<index>, whose value is the ManufacturingLine's readable slug (e.g.
// "heidelberg-cd-102-and-bobst-sp-104"). The slug is computed by the server (see
// LayoutCombinationsFinder::ManufacturingLine#slug) and carried verbatim, so the client never has to
// build or parse it. Sections are keyed by the same `index` the finder already uses for its fetch, so
// the parameter is stable across reloads.

const parameterName = (index) => `manufacturing_line_${index}`;

// The slug stored for this section, or null when none is selected.
export const readSelectedManufacturingLineSlug = (index) => {
  const parameters = new URLSearchParams(window.location.search);
  return parameters.get(parameterName(index)) || null;
};

// Keep the address bar in sync with this section's selection so a refresh / shared link reproduces it.
// replaceState (not pushState) is used deliberately — this is a mirror, not in-page navigation: it adds
// no history entries, so the browser Back button never lands mid-flow (which would desync once a solution
// is picked and this finder unmounts). A same-origin relative URL is used so only the query string changes.
export const writeSelectedManufacturingLineSlug = (index, slug) => {
  const url = new URL(window.location.href);
  url.searchParams.set(parameterName(index), slug);
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
};

// Remove this section's slug from the address bar (used by "back to machines").
export const clearSelectedManufacturingLineSlug = (index) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(parameterName(index));
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
};
